import laptopVisual from "../../assets/images/laptop2.png";

const SectionWebsiteDefinition: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(180deg,#fff8f8_0%,#ffffff_100%)] py-14 sm:py-16 lg:py-20">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-[-120px] top-10 h-72 w-72 rounded-full bg-red-100/70 blur-3xl" />
        <div className="absolute bottom-0 right-[-80px] h-80 w-80 rounded-full bg-rose-100/70 blur-3xl" />
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.95fr)] lg:gap-14">
          <div className="order-2 lg:order-1">
            <img
              src={laptopVisual}
              alt="Thiết kế website TrioCore Solutions"
              className="mx-auto h-auto w-full max-w-[640px] object-contain"
              width="640"
              height="450"
              loading="lazy"
            />
          </div>

          <div className="order-1 text-left lg:order-2">
            <span className="inline-flex rounded-full border border-red-500/20 bg-red-50 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-red-700">
              Dịch vụ website
            </span>

            <h2 className="mt-4 text-[26px] font-semibold leading-[1.18] text-[#d92d20] sm:text-[32px] lg:text-[42px]">
              Thiết Kế Website Là Gì?
            </h2>

            <div className="mt-5 space-y-4 text-[14px] leading-7 text-slate-600 sm:text-[15px]">
              <p>
                Thiết kế website hiểu đơn giản là tạo ra một trang web cho một cá nhân, doanh nghiệp hay tổ
                chức để phục vụ cho nhiều nhu cầu khác nhau như bán hàng, quảng bá sản phẩm / dịch vụ, xây
                dựng hình ảnh doanh nghiệp uy tín, cung cấp thông tin cho người dùng,...
              </p>

              <p>
                Tùy theo nhu cầu và mục đích sử dụng của chủ website mà trang web sẽ được phát triển các
                chức năng cũng như giao diện phù hợp.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionWebsiteDefinition;
